// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"OK-z","carouselContainer":"PK-z"};